'use strict';

var _require = require('any-signal'),
    anySignal = _require.anySignal;
/**
 * @typedef {AbortSignal | undefined} MaybeSignal
 *
 * @param  {MaybeSignal[]} signals
 * @returns {AbortSignal[]}
 */


function filter(signals) {
  // @ts-ignore
  return signals.filter(Boolean);
}
/**
 * @param  {...AbortSignal|undefined} signals
 */


module.exports = function () {
  for (var _len = arguments.length, signals = new Array(_len), _key = 0; _key < _len; _key++) {
    signals[_key] = arguments[_key];
  }

  return anySignal(filter(signals));
};